import { html } from 'lit'

import { FieldRenderer } from '../types.js'

export const OxGristRendererTextSelect: FieldRenderer = (value, column, record, rowIndex, field) => {
  var text = value == null ? '' : value
  return html`<span data-reactive-tooltip>${text}</span>`
}
